module.exports = __webpack_public_path__ + "img/finish.4eccb606.png";